import React from "react";
import { motion } from "framer-motion";

// Masked line-by-line reveal for headings
export const RevealLines = ({ lines, className = "", delay = 0, tag: Tag = "h2", immediate = false }) => {
  const anim = immediate
    ? { animate: { y: "0%" } }
    : { whileInView: { y: "0%" }, viewport: { once: true, margin: "-8%" } };
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            {...anim}
            transition={{ duration: 0.9, delay: delay + i * 0.09, ease: [0.19, 1, 0.22, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 28 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.8, delay, ease: [0.19, 1, 0.22, 1] }}
  >
    {children}
  </motion.div>
);
